// ============ COMPLETE INTERACTIVE GERIATRIC SCALES ============
// Contains all items for clinical assessment scales

// ============ BARTHEL INDEX (0-100) ============
export const BARTHEL_ITEMS = [
  { id: "alimentacion", name: "Alimentación", max: 10, options: [
    { value: 0, label: "Incapaz. Necesita ser alimentado por otra persona" },
    { value: 5, label: "Necesita ayuda para cortar, extender mantequilla, etc." },
    { value: 10, label: "Independiente. Capaz de comer por sí solo y en un tiempo razonable" }
  ]},
  { id: "bano", name: "Baño", max: 5, options: [
    { value: 0, label: "Dependiente. Necesita alguna ayuda o supervisión" },
    { value: 5, label: "Independiente. Capaz de lavarse entero solo" }
  ]},
  { id: "vestido", name: "Vestido", max: 10, options: [
    { value: 0, label: "Dependiente. Necesita ayuda completa" },
    { value: 5, label: "Necesita ayuda pero realiza la mitad de las tareas" },
    { value: 10, label: "Independiente. Se viste y desiste sin ayuda" }
  ]},
  { id: "aseo", name: "Aseo personal", max: 5, options: [
    { value: 0, label: "Necesita ayuda con el aseo personal" },
    { value: 5, label: "Independiente. Realiza todas las actividades personales sin ayuda" }
  ]},
  { id: "deposicion", name: "Deposición (control anal)", max: 10, options: [
    { value: 0, label: "Incontinente o necesita administración de enemas" },
    { value: 5, label: "Accidente ocasional (máximo uno por semana)" },
    { value: 10, label: "Continente. Sin episodios de incontinencia" }
  ]},
  { id: "miccion", name: "Micción (control vesical)", max: 10, options: [
    { value: 0, label: "Incontinente o sondado incapaz de cambiarse la bolsa" },
    { value: 5, label: "Accidente ocasional (máximo uno por 24 horas)" },
    { value: 10, label: "Continente. Sin episodios de incontinencia" }
  ]},
  { id: "retrete", name: "Uso del retrete", max: 10, options: [
    { value: 0, label: "Dependiente" },
    { value: 5, label: "Necesita alguna ayuda, pero puede hacer algo solo" },
    { value: 10, label: "Independiente. Entra, sale, se limpia y se viste sin ayuda" }
  ]},
  { id: "traslado", name: "Traslado cama-silla", max: 15, options: [
    { value: 0, label: "Incapaz. No se mantiene sentado" },
    { value: 5, label: "Necesita ayuda importante (persona fuerte o entrenada)" },
    { value: 10, label: "Necesita algo de ayuda (pequeña ayuda física o verbal)" },
    { value: 15, label: "Independiente. No necesita ayuda" }
  ]},
  { id: "deambulacion", name: "Deambulación", max: 15, options: [
    { value: 0, label: "Inmóvil o menos de 50 metros" },
    { value: 5, label: "Independiente en silla de ruedas, incluyendo esquinas (>50m)" },
    { value: 10, label: "Camina con ayuda de una persona (física o verbal) más de 50m" },
    { value: 15, label: "Independiente al menos 50m, con o sin bastón/andador" }
  ]},
  { id: "escaleras", name: "Subir y bajar escaleras", max: 10, options: [
    { value: 0, label: "Incapaz de usar escaleras" },
    { value: 5, label: "Necesita ayuda física o verbal" },
    { value: 10, label: "Independiente para subir y bajar" }
  ]}
];

export const interpretBarthel = (score) => {
  if (score === 100) return { text: "Independiente", color: "emerald", risk: "bajo" };
  if (score >= 91) return { text: "Dependencia escasa", color: "emerald", risk: "bajo" };
  if (score >= 61) return { text: "Dependencia moderada", color: "amber", risk: "medio" };
  if (score >= 21) return { text: "Dependencia severa", color: "red", risk: "alto" };
  return { text: "Dependencia total", color: "red", risk: "alto" };
};

// ============ MINI-MENTAL STATE EXAMINATION (0-30) ============
export const MMSE_SECTIONS = [
  {
    id: "orientacion_tiempo",
    name: "Orientación en tiempo",
    maxPoints: 5,
    items: [
      { id: "anio", question: "¿En qué año estamos?", points: 1 },
      { id: "estacion", question: "¿En qué estación del año estamos?", points: 1 },
      { id: "dia_mes", question: "¿Qué día del mes es hoy?", points: 1 },
      { id: "dia_semana", question: "¿Qué día de la semana es hoy?", points: 1 },
      { id: "mes", question: "¿En qué mes estamos?", points: 1 }
    ]
  },
  {
    id: "orientacion_lugar",
    name: "Orientación en lugar",
    maxPoints: 5,
    items: [
      { id: "pais", question: "¿En qué país estamos?", points: 1 },
      { id: "provincia", question: "¿En qué provincia/estado estamos?", points: 1 },
      { id: "ciudad", question: "¿En qué ciudad estamos?", points: 1 },
      { id: "lugar", question: "¿En qué lugar estamos? (hospital, consultorio, casa)", points: 1 },
      { id: "piso", question: "¿En qué piso/planta estamos?", points: 1 }
    ]
  },
  {
    id: "registro",
    name: "Registro (memoria inmediata)",
    maxPoints: 3,
    instruction: "Registre la memoria inmediata con 3 palabras u objetos elegidos por usted. Un punto por cada ítem recordado correctamente en el primer intento.",
    items: [
      { id: "objeto1", question: "Ítem 1 de registro inmediato", points: 1 },
      { id: "objeto2", question: "Ítem 2 de registro inmediato", points: 1 },
      { id: "objeto3", question: "Ítem 3 de registro inmediato", points: 1 }
    ]
  },
  {
    id: "atencion_calculo",
    name: "Atención y cálculo",
    maxPoints: 5,
    instruction: "Aplique la tarea de atención y cálculo que utilice en su práctica. Un punto por cada respuesta correcta.",
    items: [
      { id: "calc1", question: "Respuesta correcta 1 de 5", points: 1 },
      { id: "calc2", question: "Respuesta correcta 2 de 5", points: 1 },
      { id: "calc3", question: "Respuesta correcta 3 de 5", points: 1 },
      { id: "calc4", question: "Respuesta correcta 4 de 5", points: 1 },
      { id: "calc5", question: "Respuesta correcta 5 de 5", points: 1 }
    ]
  },
  {
    id: "recuerdo",
    name: "Recuerdo diferido",
    maxPoints: 3,
    instruction: "Solicite el recuerdo diferido de los 3 ítems registrados previamente. Un punto por cada ítem recordado sin pistas.",
    items: [
      { id: "recuerdo1", question: "Recuerdo ítem 1", points: 1 },
      { id: "recuerdo2", question: "Recuerdo ítem 2", points: 1 },
      { id: "recuerdo3", question: "Recuerdo ítem 3", points: 1 }
    ]
  },
  {
    id: "lenguaje",
    name: "Lenguaje",
    maxPoints: 9,
    items: [
      { id: "nombrar1", question: "Nombrado: objeto 1", points: 1 },
      { id: "nombrar2", question: "Nombrado: objeto 2", points: 1 },
      { id: "repetir", question: "Repetición de frase", points: 1 },
      { id: "orden1", question: "Comprensión y ejecución: orden 1 de 3", points: 1 },
      { id: "orden2", question: "Comprensión y ejecución: orden 2 de 3", points: 1 },
      { id: "orden3", question: "Comprensión y ejecución: orden 3 de 3", points: 1 },
      { id: "leer", question: "Lectura y obediencia a orden escrita", points: 1 },
      { id: "escribir", question: "Escritura de una oración con sentido", points: 1 },
      { id: "copiar", question: "Copia de figura geométrica", points: 1 }
    ]
  }
];

export const interpretMMSE = (score) => {
  if (score >= 27) return { text: "Cognición normal", color: "emerald", risk: "bajo" };
  if (score >= 24) return { text: "Deterioro cognitivo leve", color: "amber", risk: "medio" };
  if (score >= 18) return { text: "Deterioro cognitivo moderado", color: "amber", risk: "medio" };
  if (score >= 10) return { text: "Deterioro cognitivo severo", color: "red", risk: "alto" };
  return { text: "Deterioro cognitivo muy severo", color: "red", risk: "alto" };
};

// ============ MNA-SF (Mini Nutritional Assessment - Short Form) (0-14) ============
export const MNA_ITEMS = [
  {
    id: "apetito",
    name: "A. ¿Ha disminuido la ingesta de alimentos en los últimos 3 meses?",
    options: [
      { value: 0, label: "Disminución grave de la ingesta" },
      { value: 1, label: "Disminución moderada de la ingesta" },
      { value: 2, label: "Sin disminución de la ingesta" }
    ]
  },
  {
    id: "peso",
    name: "B. Pérdida de peso en los últimos 3 meses",
    options: [
      { value: 0, label: "Pérdida de peso > 3 kg" },
      { value: 1, label: "No sabe" },
      { value: 2, label: "Pérdida de peso entre 1 y 3 kg" },
      { value: 3, label: "Sin pérdida de peso" }
    ]
  },
  {
    id: "movilidad",
    name: "C. Movilidad",
    options: [
      { value: 0, label: "De la cama al sillón" },
      { value: 1, label: "Autonomía en el interior" },
      { value: 2, label: "Sale del domicilio" }
    ]
  },
  {
    id: "estres",
    name: "D. ¿Ha tenido enfermedad aguda o estrés psicológico en los últimos 3 meses?",
    options: [
      { value: 0, label: "Sí" },
      { value: 2, label: "No" }
    ]
  },
  {
    id: "neuropsicologico",
    name: "E. Problemas neuropsicológicos",
    options: [
      { value: 0, label: "Demencia o depresión grave" },
      { value: 1, label: "Demencia leve" },
      { value: 2, label: "Sin problemas psicológicos" }
    ]
  },
  {
    id: "imc",
    name: "F. Índice de masa corporal (IMC = peso/talla²)",
    options: [
      { value: 0, label: "IMC < 19" },
      { value: 1, label: "IMC 19 a < 21" },
      { value: 2, label: "IMC 21 a < 23" },
      { value: 3, label: "IMC ≥ 23" }
    ]
  }
];

export const interpretMNA = (score) => {
  if (score >= 12) return { text: "Estado nutricional normal", color: "emerald", risk: "bajo" };
  if (score >= 8) return { text: "Riesgo de malnutrición", color: "amber", risk: "medio" };
  return { text: "Malnutrición", color: "red", risk: "alto" };
};

// ============ YESAVAGE GDS-15 (Geriatric Depression Scale) (0-15) ============
export const YESAVAGE_ITEMS = [
  { id: "q1", question: "¿Está satisfecho/a con su vida?", depression: "no" },
  { id: "q2", question: "¿Ha renunciado a muchas de sus actividades e intereses?", depression: "si" },
  { id: "q3", question: "¿Siente que su vida está vacía?", depression: "si" },
  { id: "q4", question: "¿Se aburre con frecuencia?", depression: "si" },
  { id: "q5", question: "¿Tiene esperanza en el futuro?", depression: "no" },
  { id: "q6", question: "¿Le molestan pensamientos que no puede sacar de su cabeza?", depression: "si" },
  { id: "q7", question: "¿Está de buen humor la mayor parte del tiempo?", depression: "no" },
  { id: "q8", question: "¿Tiene miedo de que le vaya a pasar algo malo?", depression: "si" },
  { id: "q9", question: "¿Se siente feliz la mayor parte del tiempo?", depression: "no" },
  { id: "q10", question: "¿Se siente a menudo desamparado/a o desvalido/a?", depression: "si" },
  { id: "q11", question: "¿Se siente a menudo intranquilo/a o nervioso/a?", depression: "si" },
  { id: "q12", question: "¿Prefiere quedarse en casa en lugar de salir y hacer cosas nuevas?", depression: "si" },
  { id: "q13", question: "¿Se preocupa a menudo por el futuro?", depression: "si" },
  { id: "q14", question: "¿Cree que tiene más problemas de memoria que la mayoría?", depression: "si" },
  { id: "q15", question: "¿Piensa que es maravilloso estar vivo/a?", depression: "no" }
];

export const interpretYesavage = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s <= 4) return { text: "Normal", color: "emerald", risk: "bajo" };
  if (s <= 8) return { text: "Depresión leve", color: "amber", risk: "medio" };
  if (s <= 11) return { text: "Depresión moderada", color: "red", risk: "alto" };
  return { text: "Depresión severa", color: "red", risk: "alto" };
};

/**
 * GDS-15: suma 1 punto por ítem cuya respuesta coincide con la señal de depresión del ítem.
 * Claves canónicas: q1–q15 (YESAVAGE_ITEMS). Compatibilidad lectura: y1–y15 (datos antiguos).
 */
export function scoreYesavageFromAnswers(answers) {
  if (!answers || typeof answers !== "object") return 0;
  let sum = 0;
  for (const item of YESAVAGE_ITEMS) {
    const legacyKey = `y${String(item.id).replace(/^q/, "")}`;
    const v =
      answers[item.id] !== undefined && answers[item.id] !== null
        ? answers[item.id]
        : answers[legacyKey];
    if (v === undefined || v === null || String(v).trim() === "") continue;
    const norm = v === "si" || v === "no" ? v : String(v).toLowerCase();
    if (norm === item.depression) sum += 1;
  }
  return sum;
}

/** Etiqueta corta alineada con interpretYesavage (resúmenes, guardado de texto). */
export function interpretYesavageLabel(score) {
  return interpretYesavage(score).text;
}

// ============ PHQ-9 (0-27) ============
const PHQ9_OPTIONS = [
  { value: 0, label: "Nunca" },
  { value: 1, label: "Varios días" },
  { value: 2, label: "Más de la mitad de los días" },
  { value: 3, label: "Casi todos los días" },
];

export const PHQ9_ITEMS = [
  { id: "phq1", name: "Poco interés o placer en hacer cosas", options: PHQ9_OPTIONS },
  { id: "phq2", name: "Sentirse decaído/a, deprimido/a o sin esperanza", options: PHQ9_OPTIONS },
  { id: "phq3", name: "Dificultad para dormir o dormir en exceso", options: PHQ9_OPTIONS },
  { id: "phq4", name: "Cansancio o falta de energía", options: PHQ9_OPTIONS },
  { id: "phq5", name: "Falta de apetito o comer en exceso", options: PHQ9_OPTIONS },
  { id: "phq6", name: "Sentirse mal consigo mismo/a o que ha fallado", options: PHQ9_OPTIONS },
  { id: "phq7", name: "Dificultad para concentrarse", options: PHQ9_OPTIONS },
  { id: "phq8", name: "Hablar/moverse lento o inquietud marcada", options: PHQ9_OPTIONS },
  { id: "phq9", name: "Pensamientos de que estaría mejor muerto/a o de hacerse daño", options: PHQ9_OPTIONS },
];

export const interpretPhq9 = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s <= 4) return { text: "Depresión mínima", color: "emerald", risk: "bajo" };
  if (s <= 9) return { text: "Depresión leve", color: "amber", risk: "medio" };
  if (s <= 14) return { text: "Depresión moderada", color: "amber", risk: "medio" };
  if (s <= 19) return { text: "Depresión moderadamente grave", color: "red", risk: "alto" };
  return { text: "Depresión grave", color: "red", risk: "alto" };
};

// ============ GAD-7 (0-21) ============
const GAD7_OPTIONS = [
  { value: 0, label: "Nunca" },
  { value: 1, label: "Varios días" },
  { value: 2, label: "Más de la mitad de los días" },
  { value: 3, label: "Casi todos los días" },
];

export const GAD7_ITEMS = [
  { id: "gad1", name: "Sentirse nervioso/a, ansioso/a o al límite", options: GAD7_OPTIONS },
  { id: "gad2", name: "No poder dejar de preocuparse o controlar la preocupación", options: GAD7_OPTIONS },
  { id: "gad3", name: "Preocuparse demasiado por diferentes cosas", options: GAD7_OPTIONS },
  { id: "gad4", name: "Dificultad para relajarse", options: GAD7_OPTIONS },
  { id: "gad5", name: "Estar tan inquieto/a que es difícil quedarse quieto/a", options: GAD7_OPTIONS },
  { id: "gad6", name: "Irritarse o molestarse fácilmente", options: GAD7_OPTIONS },
  { id: "gad7", name: "Sentir miedo como si algo terrible pudiera pasar", options: GAD7_OPTIONS },
];

export const interpretGad7 = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s <= 4) return { text: "Ansiedad mínima (tamizaje negativo habitual)", color: "emerald", risk: "bajo" };
  if (s <= 9) return { text: "Ansiedad leve", color: "amber", risk: "medio" };
  if (s <= 14) return { text: "Ansiedad moderada; valorar impacto funcional y seguimiento", color: "amber", risk: "medio" };
  return { text: "Ansiedad grave; considerar evaluación y manejo específico", color: "red", risk: "alto" };
};

// ============ KATZ INDEX (0-6) ============
export const KATZ_ITEMS = [
  { id: "bano", name: "Baño", description: "Se baña completamente solo o necesita ayuda solo para lavar una parte (espalda, piernas)", 
    options: [{ value: 1, label: "Independiente" }, { value: 0, label: "Dependiente" }] },
  { id: "vestido", name: "Vestido", description: "Toma la ropa del armario, se viste y se abrocha. Se excluye atarse los zapatos", 
    options: [{ value: 1, label: "Independiente" }, { value: 0, label: "Dependiente" }] },
  { id: "inodoro", name: "Uso del inodoro", description: "Va al baño, se sienta, se limpia y se viste. Puede usar ayudas técnicas", 
    options: [{ value: 1, label: "Independiente" }, { value: 0, label: "Dependiente" }] },
  { id: "transferencia", name: "Transferencia", description: "Entra y sale de la cama o silla sin ayuda (puede usar ayudas mecánicas)", 
    options: [{ value: 1, label: "Independiente" }, { value: 0, label: "Dependiente" }] },
  { id: "continencia", name: "Continencia", description: "Control completo de micción y defecación", 
    options: [{ value: 1, label: "Independiente" }, { value: 0, label: "Dependiente" }] },
  { id: "alimentacion", name: "Alimentación", description: "Lleva la comida del plato a la boca. Excluye cortar carne o untar mantequilla", 
    options: [{ value: 1, label: "Independiente" }, { value: 0, label: "Dependiente" }] }
];

export const interpretKatz = (score) => {
  if (score === 6) return { text: "Independiente (A)", color: "emerald", risk: "bajo" };
  if (score === 5) return { text: "Dependencia leve (B)", color: "emerald", risk: "bajo" };
  if (score >= 3) return { text: "Dependencia moderada (C-D)", color: "amber", risk: "medio" };
  if (score >= 1) return { text: "Dependencia severa (E-F)", color: "red", risk: "alto" };
  return { text: "Dependencia total (G)", color: "red", risk: "alto" };
};

// ============ LAWTON IADL (0-8) ============
// Each option needs unique id for RadioGroup - use optId 0,1,2,3; score = options[optId].value
export const LAWTON_ITEMS = [
  { id: "telefono", name: "Uso del teléfono", options: [
    { optId: 0, value: 1, label: "Utiliza el teléfono por iniciativa propia" },
    { optId: 1, value: 1, label: "Marca números conocidos" },
    { optId: 2, value: 1, label: "Contesta, pero no marca" },
    { optId: 3, value: 0, label: "No utiliza el teléfono" }
  ]},
  { id: "compras", name: "Hacer compras", options: [
    { optId: 0, value: 1, label: "Realiza todas las compras necesarias" },
    { optId: 1, value: 0, label: "Solo realiza compras pequeñas" },
    { optId: 2, value: 0, label: "Necesita compañía para cualquier compra" },
    { optId: 3, value: 0, label: "Incapaz de ir de compras" }
  ]},
  { id: "cocina", name: "Preparación de comida", options: [
    { optId: 0, value: 1, label: "Planea, prepara y sirve comidas adecuadas" },
    { optId: 1, value: 0, label: "Prepara comidas si se le dan los ingredientes" },
    { optId: 2, value: 0, label: "Calienta y sirve comidas preparadas" },
    { optId: 3, value: 0, label: "Necesita que le preparen y sirvan las comidas" }
  ]},
  { id: "hogar", name: "Cuidado del hogar", options: [
    { optId: 0, value: 1, label: "Mantiene la casa solo o con ayuda ocasional" },
    { optId: 1, value: 1, label: "Realiza tareas ligeras diarias" },
    { optId: 2, value: 1, label: "Realiza tareas ligeras pero no mantiene limpieza adecuada" },
    { optId: 3, value: 0, label: "Necesita ayuda en todas las tareas" },
    { optId: 4, value: 0, label: "No participa en ninguna tarea" }
  ]},
  { id: "lavado", name: "Lavado de ropa", options: [
    { optId: 0, value: 1, label: "Lava toda su ropa solo/a" },
    { optId: 1, value: 1, label: "Lava prendas pequeñas" },
    { optId: 2, value: 0, label: "Todo el lavado debe ser realizado por otro" }
  ]},
  { id: "transporte", name: "Uso de transporte", options: [
    { optId: 0, value: 1, label: "Viaja solo en transporte público o conduce" },
    { optId: 1, value: 1, label: "Viaja en taxi pero no en transporte público" },
    { optId: 2, value: 0, label: "Viaja en transporte con acompañante" },
    { optId: 3, value: 0, label: "Viaja solo en taxi o auto con ayuda" },
    { optId: 4, value: 0, label: "No viaja en absoluto" }
  ]},
  { id: "medicacion", name: "Responsabilidad con medicamentos", options: [
    { optId: 0, value: 1, label: "Toma su medicación a la hora y dosis correcta" },
    { optId: 1, value: 0, label: "Toma su medicación si se le prepara" },
    { optId: 2, value: 0, label: "No es capaz de administrar su medicación" }
  ]},
  { id: "finanzas", name: "Capacidad de usar dinero", options: [
    { optId: 0, value: 1, label: "Maneja asuntos financieros de forma independiente" },
    { optId: 1, value: 1, label: "Maneja compras diarias pero necesita ayuda para grandes gastos" },
    { optId: 2, value: 0, label: "Incapaz de manejar dinero" }
  ]}
];

export const interpretLawton = (score) => {
  if (score === 8) return { text: "Independencia total", color: "emerald", risk: "bajo" };
  if (score >= 6) return { text: "Dependencia leve", color: "emerald", risk: "bajo" };
  if (score >= 4) return { text: "Dependencia moderada", color: "amber", risk: "medio" };
  if (score >= 2) return { text: "Dependencia severa", color: "red", risk: "alto" };
  return { text: "Dependencia total", color: "red", risk: "alto" };
};

/** Convert Lawton optId answers to score answers for API (optId stored in UI, backend expects scores) */
export const convertLawtonAnswersForApi = (answers) => {
  if (!answers || typeof answers !== "object") return answers;
  const out = {};
  LAWTON_ITEMS.forEach((item) => {
    const raw = answers[item.id];
    if (raw === undefined) return;
    const opt = item.options.find(o => o.optId === raw || o.optId === parseInt(raw));
    out[item.id] = opt ? opt.value : raw;
  });
  return Object.keys(out).length ? out : answers;
};

/** Convert Lawton score answers from API back to optIds for UI display (loading draft/consultation) */
export const convertLawtonScoresToOptIds = (answers) => {
  if (!answers || typeof answers !== "object") return answers;
  const out = {};
  LAWTON_ITEMS.forEach((item) => {
    const scoreVal = answers[item.id];
    if (scoreVal === undefined) return;
    const opt = item.options.find(o => o.value === scoreVal || o.value === parseInt(scoreVal));
    out[item.id] = opt ? opt.optId : scoreVal;
  });
  return Object.keys(out).length ? out : answers;
};

// ============ MORSE FALL SCALE (0-125) ============
export const MORSE_ITEMS = [
  { id: "historia_caidas", name: "Historial de caídas (últimos 3 meses)", options: [
    { value: 0, label: "No" },
    { value: 25, label: "Sí" }
  ]},
  { id: "diagnostico_secundario", name: "Diagnóstico secundario (>1 diagnóstico)", options: [
    { value: 0, label: "No" },
    { value: 15, label: "Sí" }
  ]},
  { id: "ayuda_deambular", name: "Ayuda para deambular", options: [
    { value: 0, label: "Ninguna / Reposo en cama / Asistencia de enfermera" },
    { value: 15, label: "Bastón / Andador / Muletas" },
    { value: 30, label: "Se apoya en muebles para caminar" }
  ]},
  { id: "via_iv", name: "Terapia IV / Catéter con heparina", options: [
    { value: 0, label: "No" },
    { value: 20, label: "Sí" }
  ]},
  { id: "marcha", name: "Marcha", options: [
    { value: 0, label: "Normal / Reposo en cama / Silla de ruedas" },
    { value: 10, label: "Débil (camina encorvado pero levanta la cabeza)" },
    { value: 20, label: "Alterada (arrastra los pies, pasos cortos, tambaleo)" }
  ]},
  { id: "estado_mental", name: "Estado mental", options: [
    { value: 0, label: "Consciente de sus limitaciones" },
    { value: 15, label: "Sobreestima sus capacidades / Olvida sus limitaciones" }
  ]}
];

export const interpretMorse = (score) => {
  if (score <= 24) return { text: "Riesgo bajo de caídas", color: "emerald", risk: "bajo" };
  if (score <= 44) return { text: "Riesgo moderado de caídas", color: "amber", risk: "medio" };
  return { text: "Riesgo alto de caídas", color: "red", risk: "alto" };
};

// ============ TINETTI (POMA) - Balance and Gait (0-28) ============
export const TINETTI_BALANCE_ITEMS = [
  { id: "equilibrio_sentado", name: "Equilibrio sentado", options: [
    { value: 0, label: "Se inclina o desliza en la silla" },
    { value: 1, label: "Se mantiene seguro, estable" }
  ]},
  { id: "levantarse", name: "Levantarse", options: [
    { value: 0, label: "Incapaz sin ayuda o pierde el equilibrio" },
    { value: 1, label: "Capaz, pero usa los brazos para ayudarse" },
    { value: 2, label: "Capaz sin usar los brazos" }
  ]},
  { id: "intentos_levantarse", name: "Intentos para levantarse", options: [
    { value: 0, label: "Incapaz sin ayuda" },
    { value: 1, label: "Capaz, pero necesita más de un intento" },
    { value: 2, label: "Capaz de levantarse con un solo intento" }
  ]},
  { id: "equilibrio_inmediato", name: "Equilibrio inmediato al ponerse de pie (primeros 5 seg)", options: [
    { value: 0, label: "Inestable (tambalea, mueve los pies)" },
    { value: 1, label: "Estable pero usa andador o bastón u otro soporte" },
    { value: 2, label: "Estable sin andador ni otro soporte" }
  ]},
  { id: "equilibrio_pie", name: "Equilibrio de pie", options: [
    { value: 0, label: "Inestable" },
    { value: 1, label: "Estable pero con pies separados (>10cm) o usa bastón" },
    { value: 2, label: "Base de sustentación estrecha sin soporte" }
  ]},
  { id: "empujon", name: "Empujón (paciente de pie con pies juntos, empujar suavemente el esternón 3 veces)", options: [
    { value: 0, label: "Empieza a caerse" },
    { value: 1, label: "Se tambalea, agarra, pero se mantiene" },
    { value: 2, label: "Estable" }
  ]},
  { id: "ojos_cerrados", name: "Ojos cerrados (de pie)", options: [
    { value: 0, label: "Inestable" },
    { value: 1, label: "Estable" }
  ]},
  { id: "giro_360", name: "Giro 360°", options: [
    { value: 0, label: "Pasos discontinuos" },
    { value: 1, label: "Pasos continuos" },
    { value: 0, label: "Inestable (agarra, tambalea)" },
    { value: 1, label: "Estable" }
  ]},
  { id: "sentarse", name: "Sentarse", options: [
    { value: 0, label: "Inseguro, calcula mal la distancia, cae en la silla" },
    { value: 1, label: "Usa los brazos o no tiene movimiento suave" },
    { value: 2, label: "Seguro, movimiento suave" }
  ]}
];

export const TINETTI_GAIT_ITEMS = [
  { id: "inicio_marcha", name: "Inicio de la marcha (inmediatamente después de decir 'camine')", options: [
    { value: 0, label: "Cualquier vacilación o múltiples intentos para empezar" },
    { value: 1, label: "Sin vacilación" }
  ]},
  { id: "longitud_paso_derecho", name: "Longitud y altura del paso (pie derecho)", options: [
    { value: 0, label: "No sobrepasa el pie izquierdo" },
    { value: 1, label: "Sobrepasa el pie izquierdo" },
    { value: 0, label: "El pie derecho no se levanta completamente del suelo" },
    { value: 1, label: "El pie derecho se levanta completamente" }
  ]},
  { id: "longitud_paso_izquierdo", name: "Longitud y altura del paso (pie izquierdo)", options: [
    { value: 0, label: "No sobrepasa el pie derecho" },
    { value: 1, label: "Sobrepasa el pie derecho" },
    { value: 0, label: "El pie izquierdo no se levanta completamente del suelo" },
    { value: 1, label: "El pie izquierdo se levanta completamente" }
  ]},
  { id: "simetria_paso", name: "Simetría del paso", options: [
    { value: 0, label: "La longitud de los pasos con el pie derecho e izquierdo no es igual" },
    { value: 1, label: "La longitud parece igual" }
  ]},
  { id: "continuidad_paso", name: "Continuidad del paso", options: [
    { value: 0, label: "Para o hay discontinuidad entre los pasos" },
    { value: 1, label: "Los pasos parecen continuos" }
  ]},
  { id: "trayectoria", name: "Trayectoria (observar el trazado del pie en 3m)", options: [
    { value: 0, label: "Desviación marcada" },
    { value: 1, label: "Leve desviación o usa ayuda para caminar" },
    { value: 2, label: "Sin desviación o uso de ayuda" }
  ]},
  { id: "tronco", name: "Tronco", options: [
    { value: 0, label: "Balanceo marcado o usa ayuda para caminar" },
    { value: 1, label: "Sin balanceo pero flexiona rodillas o espalda o usa brazos para estabilidad" },
    { value: 2, label: "Sin balanceo, flexión, uso de brazos o ayuda para caminar" }
  ]},
  { id: "postura_marcha", name: "Postura durante la marcha", options: [
    { value: 0, label: "Los talones separados" },
    { value: 1, label: "Los talones casi se tocan mientras camina" }
  ]}
];

export const interpretTinetti = (score) => {
  if (score >= 24) return { text: "Sin riesgo de caídas", color: "emerald", risk: "bajo" };
  if (score >= 19) return { text: "Riesgo bajo de caídas", color: "amber", risk: "medio" };
  return { text: "Alto riesgo de caídas", color: "red", risk: "alto" };
};

// ============ SARC-F (0-10) — Malmstrom et al., validación habitual ============
const SARC_F_TRICOTOMICO = [
  { value: 0, label: "Sin dificultad" },
  { value: 1, label: "Alguna dificultad" },
  { value: 2, label: "Mucha dificultad o no puede realizarlo" },
];

export const SARC_F_ITEMS = [
  {
    id: "fuerza",
    name: "Fuerza (levantar o cargar 4,5 kg)",
    description: "¿Tiene dificultad para levantar o cargar unas 10 libras (≈4,5 kg)?",
    options: SARC_F_TRICOTOMICO,
  },
  {
    id: "caminar",
    name: "Caminar por una habitación",
    description: "¿Tiene dificultad para caminar por una habitación u oficina?",
    options: SARC_F_TRICOTOMICO,
  },
  {
    id: "silla",
    name: "Levantarse de una silla o cama",
    description: "¿Tiene dificultad para levantarse de una silla, cama o inodoro?",
    options: SARC_F_TRICOTOMICO,
  },
  {
    id: "escaleras",
    name: "Subir un tramo de escaleras",
    description: "¿Tiene dificultad para subir un tramo de 10 escalones?",
    options: SARC_F_TRICOTOMICO,
  },
  {
    id: "caidas",
    name: "Caídas en el último año",
    description: "¿Cuántas veces se ha caído en el último año?",
    options: [
      { value: 0, label: "Ninguna" },
      { value: 1, label: "1 a 3 caídas" },
      { value: 2, label: "4 o más caídas" },
    ],
  },
];

export const interpretSarcF = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s <= 3) return { text: "Puntaje bajo: bajo riesgo de sarcopenia (tamizaje)", color: "emerald", risk: "bajo" };
  if (s <= 6) return { text: "Riesgo intermedio: considerar evaluación funcional y composición corporal", color: "amber", risk: "medio" };
  return { text: "Puntaje alto: alto riesgo de sarcopenia; valorar fuerza, rendimiento y causa", color: "red", risk: "alto" };
};

// ============ CFS — Clinical Frailty Scale (1-9) ============
export const CFS_ITEMS = [
  {
    id: "cfs_score",
    name: "Nivel de fragilidad (CFS)",
    options: [
      { value: 1, label: "Muy en forma" },
      { value: 2, label: "Bien" },
      { value: 3, label: "Bien manejado" },
      { value: 4, label: "Vulnerable" },
      { value: 5, label: "Fragilidad leve" },
      { value: 6, label: "Fragilidad moderada" },
      { value: 7, label: "Fragilidad severa" },
      { value: 8, label: "Fragilidad muy severa" },
      { value: 9, label: "Enfermedad terminal" },
    ],
  },
];

export const interpretCFS = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s <= 3) return { text: s === 1 ? "Muy en forma" : s === 2 ? "Bien" : "Bien manejado", color: "emerald", risk: "bajo" };
  if (s === 4) return { text: "Vulnerable", color: "amber", risk: "medio" };
  if (s === 5) return { text: "Fragilidad leve", color: "amber", risk: "medio" };
  if (s === 6) return { text: "Fragilidad moderada", color: "red", risk: "alto" };
  if (s === 7) return { text: "Fragilidad severa", color: "red", risk: "alto" };
  if (s === 8) return { text: "Fragilidad muy severa", color: "red", risk: "alto" };
  return { text: "Enfermedad terminal", color: "red", risk: "alto" };
};

// ============ FRAIL SCALE (0-5) ============
export const FRAIL_ITEMS = [
  { id: "fatiga", name: "F - Fatigue (Fatiga)", 
    question: "¿Qué parte del tiempo durante las últimas 4 semanas se sintió cansado/a?",
    options: [
      { value: 0, label: "Nunca / Rara vez / A veces" },
      { value: 1, label: "La mayor parte del tiempo / Siempre" }
    ]
  },
  { id: "resistencia", name: "R - Resistance (Resistencia)", 
    question: "¿Tiene dificultad para subir 10 escalones sin descansar?",
    options: [
      { value: 0, label: "No" },
      { value: 1, label: "Sí" }
    ]
  },
  { id: "ambulacion", name: "A - Ambulation (Ambulación)", 
    question: "¿Tiene dificultad para caminar varios cientos de metros?",
    options: [
      { value: 0, label: "No" },
      { value: 1, label: "Sí" }
    ]
  },
  { id: "enfermedades", name: "I - Illnesses (Enfermedades)", 
    question: "¿Tiene 5 o más de estas enfermedades: hipertensión, diabetes, cáncer, enfermedad pulmonar, infarto, insuficiencia cardíaca, angina, asma, artritis, ACV, enfermedad renal?",
    options: [
      { value: 0, label: "No (0-4 enfermedades)" },
      { value: 1, label: "Sí (5+ enfermedades)" }
    ]
  },
  { id: "peso", name: "L - Loss of weight (Pérdida de peso)", 
    question: "¿Ha perdido más del 5% de su peso en los últimos 6 meses?",
    options: [
      { value: 0, label: "No" },
      { value: 1, label: "Sí" }
    ]
  }
];

export const interpretFRAIL = (score) => {
  if (score === 0) return { text: "Robusto", color: "emerald", risk: "bajo" };
  if (score <= 2) return { text: "Pre-frágil", color: "amber", risk: "medio" };
  return { text: "Frágil", color: "red", risk: "alto" };
};

// ============ PFEIFFER SPMSQ (0-10 errors) ============
export const PFEIFFER_ITEMS = [
  { id: "q1", question: "¿Qué fecha es hoy? (día, mes, año)", correctIf: "exact" },
  { id: "q2", question: "¿Qué día de la semana es hoy?", correctIf: "exact" },
  { id: "q3", question: "¿Cómo se llama este lugar?", correctIf: "place" },
  { id: "q4", question: "¿Cuál es su número de teléfono? (Si no tiene: ¿Cuál es su dirección?)", correctIf: "known" },
  { id: "q5", question: "¿Cuántos años tiene?", correctIf: "exact" },
  { id: "q6", question: "¿Cuál es la fecha de su nacimiento? (día, mes, año)", correctIf: "exact" },
  { id: "q7", question: "¿Cómo se llama el presidente del país?", correctIf: "exact" },
  { id: "q8", question: "¿Cómo se llamaba el anterior presidente?", correctIf: "exact" },
  { id: "q9", question: "¿Cuál era el apellido de soltera de su madre?", correctIf: "known" },
  { id: "q10", question: "Reste de 3 en 3 desde 20 (20, 17, 14, 11, 8, 5, 2)", correctIf: "sequence" }
];

export const interpretPfeiffer = (errors) => {
  // Note: Score is number of ERRORS, not correct answers
  if (errors <= 2) return { text: "Funcionamiento intelectual intacto", color: "emerald", risk: "bajo" };
  if (errors <= 4) return { text: "Deterioro intelectual leve", color: "amber", risk: "medio" };
  if (errors <= 7) return { text: "Deterioro intelectual moderado", color: "red", risk: "alto" };
  return { text: "Deterioro intelectual severo", color: "red", risk: "alto" };
};

// ============ NORTON SCALE (5-20) ============
export const NORTON_ITEMS = [
  { id: "estado_fisico", name: "Estado físico general", options: [
    { value: 1, label: "Muy malo" },
    { value: 2, label: "Malo" },
    { value: 3, label: "Regular" },
    { value: 4, label: "Bueno" }
  ]},
  { id: "estado_mental", name: "Estado mental", options: [
    { value: 1, label: "Comatoso / Estuporoso" },
    { value: 2, label: "Confuso" },
    { value: 3, label: "Apático" },
    { value: 4, label: "Alerta" }
  ]},
  { id: "actividad", name: "Actividad", options: [
    { value: 1, label: "Encamado" },
    { value: 2, label: "En silla de ruedas" },
    { value: 3, label: "Camina con ayuda" },
    { value: 4, label: "Ambulante" }
  ]},
  { id: "movilidad", name: "Movilidad", options: [
    { value: 1, label: "Inmóvil" },
    { value: 2, label: "Muy limitada" },
    { value: 3, label: "Ligeramente limitada" },
    { value: 4, label: "Completa" }
  ]},
  { id: "incontinencia", name: "Incontinencia", options: [
    { value: 1, label: "Urinaria y fecal" },
    { value: 2, label: "Urinaria o fecal" },
    { value: 3, label: "Ocasional" },
    { value: 4, label: "Ninguna" }
  ]}
];

export const interpretNorton = (score) => {
  if (score >= 14) return { text: "Riesgo mínimo de úlceras por presión", color: "emerald", risk: "bajo" };
  if (score >= 12) return { text: "Riesgo evidente de úlceras por presión", color: "amber", risk: "medio" };
  return { text: "Riesgo muy alto de úlceras por presión", color: "red", risk: "alto" };
};

// ============ GIJÓN - Escala de Valoración Sociofamiliar (5-25) ============
// 5 items, each 1-5 points. Lower = better situation. Uses optId for radio selection.
export const GIJON_ITEMS = [
  { id: "situacion_familiar", name: "Situación familiar", options: [
    { optId: 1, value: 1, label: "Vive acompañado, convivencia satisfactoria y apoyo" },
    { optId: 2, value: 2, label: "Vive acompañado, convivencia problemática o sin apoyo" },
    { optId: 3, value: 3, label: "Vive solo, contacto familiar insuficiente o conflictivo" },
    { optId: 4, value: 4, label: "Vive solo, sin contacto familiar o muy esporádico" },
    { optId: 5, value: 5, label: "Vive solo y no tiene familiares" }
  ]},
  { id: "situacion_economica", name: "Situación económica", options: [
    { optId: 1, value: 1, label: "Ingresos suficientes, gestiona adecuadamente" },
    { optId: 2, value: 2, label: "Ingresos suficientes, dificultades para gestionar" },
    { optId: 3, value: 3, label: "Ingresos suficientes, necesita ayuda ocasional" },
    { optId: 4, value: 4, label: "Ingresos insuficientes, ayuda habitual" },
    { optId: 5, value: 5, label: "Sin ingresos o muy escasos" }
  ]},
  { id: "vivienda", name: "Vivienda", options: [
    { optId: 1, value: 1, label: "Adecuada, accesible, segura" },
    { optId: 2, value: 2, label: "Adecuada, necesita adaptación o mantenimiento" },
    { optId: 3, value: 3, label: "Inadecuada, posibilidad de mejora con ayuda" },
    { optId: 4, value: 4, label: "Inadecuada, paciente no colabora" },
    { optId: 5, value: 5, label: "Inadecuada, sin posibilidad de mejora" }
  ]},
  { id: "relaciones_sociales", name: "Relaciones sociales", options: [
    { optId: 1, value: 1, label: "Relaciones satisfactorias, participa en actividades" },
    { optId: 2, value: 2, label: "Relaciones satisfactorias, participación limitada" },
    { optId: 3, value: 3, label: "Relaciones insuficientes, participación ocasional" },
    { optId: 4, value: 4, label: "Relaciones insuficientes, sin participación" },
    { optId: 5, value: 5, label: "Sin relaciones o muy escasas y conflictivas" }
  ]},
  { id: "apoyos_red", name: "Apoyos de la red social", options: [
    { optId: 1, value: 1, label: "Apoyos suficientes, moviliza de forma autónoma" },
    { optId: 2, value: 2, label: "Apoyos suficientes, necesita ayuda para movilizarlos" },
    { optId: 3, value: 3, label: "Apoyos insuficientes, movilización ocasional" },
    { optId: 4, value: 4, label: "Apoyos insuficientes, movilización esporádica" },
    { optId: 5, value: 5, label: "Sin apoyos o no movilizables" }
  ]}
];

export const interpretGijon = (score) => {
  if (score <= 9) return { text: "Buena situación social", color: "emerald", risk: "bajo" };
  if (score <= 14) return { text: "Riesgo social", color: "amber", risk: "medio" };
  return { text: "Problema social", color: "red", risk: "alto" };
};

/** Convert Gijon optId answers to value answers for API */
export const convertGijonAnswersForApi = (answers) => {
  if (!answers || typeof answers !== "object") return answers;
  const out = {};
  GIJON_ITEMS.forEach((item) => {
    const raw = answers[item.id];
    if (raw === undefined) return;
    const opt = item.options.find(o => o.optId === raw || o.optId === parseInt(raw));
    out[item.id] = opt ? opt.value : raw;
  });
  return Object.keys(out).length ? out : answers;
};

/** Convert Gijon value answers from API to optIds for UI */
export const convertGijonScoresToOptIds = (answers) => {
  if (!answers || typeof answers !== "object") return answers;
  const out = {};
  GIJON_ITEMS.forEach((item) => {
    const val = answers[item.id];
    if (val === undefined) return;
    const opt = item.options.find(o => o.value === val || o.value === parseInt(val));
    out[item.id] = opt ? opt.optId : val;
  });
  return Object.keys(out).length ? out : answers;
};

// ============ ZARIT — Sobrecarga del cuidador (12 ítems, 0–48) ============
const ZARIT_FREQUENCY_OPTIONS = [
  { value: 0, label: "Nunca" },
  { value: 1, label: "Rara vez" },
  { value: 2, label: "Algunas veces" },
  { value: 3, label: "Bastantes veces" },
  { value: 4, label: "Casi siempre" },
];

export const ZARIT_ITEMS = [
  { id: "z1", name: "¿Cree que su familiar le pide más ayuda de la que realmente necesita?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z2", name: "¿Siente que no tiene tiempo suficiente para usted mismo/a?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z3", name: "¿Se ha sentido tenso/a al tener que dividirse entre el cuidado y otras responsabilidades?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z4", name: "¿Siente que su salud se ha resentido al cuidar a su familiar?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z5", name: "¿Siente que ha perdido contacto con amigos/as o con sus intereses?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z6", name: "¿Siente que ha perdido el control de su vida desde que cuida a su familiar?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z7", name: "¿Tiene miedo por el futuro de su familiar?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z8", name: "¿Siente que su familiar depende demasiado de usted?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z9", name: "¿Se ha sentido incómodo/a al tener que pedir ayuda para cuidar?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z10", name: "¿Se ha sentido avergonzado/a o enfadado/a por el comportamiento de su familiar?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z11", name: "¿Siente que debería hacer más de lo que hace por su familiar?", options: ZARIT_FREQUENCY_OPTIONS },
  { id: "z12", name: "¿En general, se siente muy sobrecargado/a al cuidar a su familiar?", options: ZARIT_FREQUENCY_OPTIONS },
];

export const interpretZarit = (score) => {
  if (score <= 10) return { text: "Sin sobrecarga", color: "emerald", risk: "bajo" };
  if (score <= 20) return { text: "Sobrecarga leve", color: "amber", risk: "medio" };
  return { text: "Sobrecarga intensa", color: "red", risk: "alto" };
};

// ============ TUG — Timed Up and Go (segundos; umbral frecuente ≥20 s riesgo aumentado) ============
export const interpretTug = (/** @type {number} */ seconds) => {
  const s = Number(seconds);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s < 10) return { text: "Movilidad dentro de rango esperado", color: "emerald", risk: "bajo" };
  if (s < 20) return { text: "Funcionalidad conservada; vigilancia según contexto clínico", color: "amber", risk: "medio" };
  if (s < 30) return { text: "Movilidad reducida; riesgo aumentado de caídas (≥20 s)", color: "amber", risk: "medio" };
  return { text: "Alteración marcada de la marcha/transferencia; alto riesgo funcional", color: "red", risk: "alto" };
};

// ============ SPPB — Short Physical Performance Battery (0-12) ============
export const scoreSppbGait = (seconds, unable) => {
  if (unable) return 0;
  const s = Number(seconds);
  if (Number.isNaN(s) || s <= 0) return null;
  if (s <= 4.82) return 4;
  if (s <= 6.2) return 3;
  if (s <= 8.7) return 2;
  return 1;
};

export const scoreSppbChair = (seconds, unable) => {
  if (unable) return 0;
  const s = Number(seconds);
  if (Number.isNaN(s) || s <= 0) return null;
  if (s <= 11.19) return 4;
  if (s <= 13.69) return 3;
  if (s <= 16.69) return 2;
  return 1;
};

export const interpretSppb = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s <= 3) return { text: "Discapacidad funcional severa", color: "red", risk: "alto" };
  if (s <= 6) return { text: "Limitación funcional moderada", color: "amber", risk: "medio" };
  if (s <= 9) return { text: "Limitación leve", color: "amber", risk: "medio" };
  return { text: "Funcionalidad conservada", color: "emerald", risk: "bajo" };
};

// ============ MoCA (Montreal Cognitive Assessment) (0-30) ============
export const interpretMoca = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s >= 26) return { text: "Cognición dentro de rango esperado", color: "emerald", risk: "bajo" };
  if (s >= 18) return { text: "Sospecha de deterioro cognitivo leve", color: "amber", risk: "medio" };
  if (s >= 10) return { text: "Deterioro cognitivo moderado", color: "red", risk: "alto" };
  return { text: "Deterioro cognitivo severo", color: "red", risk: "alto" };
};

// ============ CAM (Confusion Assessment Method) — sin suma de puntajes ============
// Criterio diagnóstico estándar: (1) y (2) presentes, y (3) o (4).
export const CAM_ITEMS = [
  {
    id: "inicio_agudo",
    name: "1. Inicio agudo y curso fluctuante",
    description: "Cambio agudo del estado mental respecto al basal, con fluctuaciones en el día o entre días.",
  },
  {
    id: "inatencion",
    name: "2. Inatención",
    description: "Dificultad clara para sostener o desplazar la atención (p. ej., vigilancia, dígitos, meses al revés).",
  },
  {
    id: "pensamiento_desorganizado",
    name: "3. Pensamiento desorganizado",
    description: "Discurso incoherente, irrelevante u oscilante; flujo de ideas desorganizado.",
  },
  {
    id: "alteracion_conciencia",
    name: "4. Alteración del nivel de conciencia",
    description: "Hipoalerta o hiperalerta; no orientado al entorno (distinto de demencia estable).",
  },
];

export const evaluateCam = (answers) => {
  const a = answers && typeof answers === "object" ? answers : {};
  const c1 = a.inicio_agudo === "si";
  const c2 = a.inatencion === "si";
  const c3 = a.pensamiento_desorganizado === "si";
  const c4 = a.alteracion_conciencia === "si";
  return c1 && c2 && (c3 || c4);
};

export const interpretCam = (value) => {
  if (value === true) return { text: "Compatible con delirium", color: "red", risk: "alto" };
  if (value === false) return { text: "No cumple criterios de delirium", color: "emerald", risk: "bajo" };
  return { text: "", color: "slate", risk: "bajo" };
};

// ============ Mini-Cog ============
export const evaluateMiniCog = (answers) => {
  const a = answers && typeof answers === "object" ? answers : {};
  const recall = Number(a.recuerdo_3_palabras);
  const clockNormal = a.reloj_normal === true || a.reloj_normal === "true";
  if (Number.isNaN(recall) || recall < 0 || recall > 3) return null;
  if (recall === 0) return true;
  if (recall === 3) return false;
  return !clockNormal;
};

export const interpretMiniCog = (value) => {
  if (value === true) return { text: "Tamizaje positivo para deterioro cognitivo", color: "red", risk: "alto" };
  if (value === false) return { text: "Tamizaje negativo", color: "emerald", risk: "bajo" };
  return { text: "", color: "slate", risk: "bajo" };
};

// ============ Polifarmacia simple (recuento; sin suma de ítems tipo escala) ============
export const POLIFARMACIA_SIMPLE_FLAG_ITEMS = [
  { id: "duplicados", label: "Duplicados terapéuticos" },
  { id: "potencialmente_inapropiados", label: "Potencialmente inapropiados" },
  { id: "dificultad_adherencia", label: "Dificultad de adherencia" },
];

/**
 * @param {number} count - Número de medicamentos de uso regular
 * @param {{ duplicados?: boolean, potencialmente_inapropiados?: boolean, dificultad_adherencia?: boolean }} flags
 */
export const interpretPolifarmaciaSimple = (count, flags = {}) => {
  const n = Math.floor(Number(count));
  if (Number.isNaN(n) || n < 0) return { text: "", color: "slate", risk: "bajo" };
  let out;
  if (n <= 4) out = { text: "Bajo riesgo", color: "emerald", risk: "bajo" };
  else if (n <= 9) out = { text: "Polifarmacia", color: "amber", risk: "medio" };
  else out = { text: "Polifarmacia severa", color: "red", risk: "alto" };

  const notes = [];
  if (flags.duplicados) notes.push("duplicados");
  if (flags.potencialmente_inapropiados) notes.push("potencialmente inapropiados");
  if (flags.dificultad_adherencia) notes.push("dificultad de adherencia");
  if (notes.length) {
    out = { ...out, text: `${out.text}. Aclaraciones: ${notes.join(", ")}.` };
  }
  return out;
};

// ============ ÍNDICE DE CHARLSON (0-37) ============
export const CHARLSON_ITEMS = [
  { id: "infarto_miocardio", name: "Infarto de miocardio", weight: 1 },
  { id: "insuficiencia_cardiaca", name: "Insuficiencia cardíaca", weight: 1 },
  { id: "enfermedad_vascular_periferica", name: "Enfermedad vascular periférica", weight: 1 },
  { id: "enfermedad_cerebrovascular", name: "Enfermedad cerebrovascular", weight: 1 },
  { id: "demencia", name: "Demencia", weight: 1 },
  { id: "enfermedad_pulmonar_cronica", name: "Enfermedad pulmonar crónica", weight: 1 },
  { id: "enfermedad_reumatologica", name: "Enfermedad reumatológica", weight: 1 },
  { id: "enfermedad_hepatica_leve", name: "Enfermedad hepática leve", weight: 1 },
  { id: "diabetes", name: "Diabetes", weight: 1 },
  { id: "hemiplejia", name: "Hemiplejia", weight: 2 },
  { id: "enfermedad_renal_moderada_grave", name: "Enfermedad renal moderada o grave", weight: 2 },
  { id: "diabetes_complicaciones", name: "Diabetes con complicaciones", weight: 2 },
  { id: "tumor_solido_no_metastasico", name: "Tumor sólido no metastásico", weight: 2 },
  { id: "leucemia", name: "Leucemia", weight: 2 },
  { id: "linfoma", name: "Linfoma", weight: 2 },
  { id: "enfermedad_hepatica_moderada_grave", name: "Enfermedad hepática moderada o grave", weight: 3 },
  { id: "tumor_metastasico", name: "Tumor metastásico", weight: 6 },
  { id: "sida", name: "SIDA", weight: 6 },
];

export const interpretCharlson = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s <= 1) return { text: "Comorbilidad baja", color: "emerald", risk: "bajo" };
  if (s <= 3) return { text: "Comorbilidad moderada", color: "amber", risk: "medio" };
  return { text: "Comorbilidad alta", color: "red", risk: "alto" };
};

// ============ EVA — Escala Visual Análoga (0-10) ============
export const interpretEvaDolor = (score) => {
  const s = Number(score);
  if (Number.isNaN(s)) return { text: "", color: "slate", risk: "bajo" };
  if (s === 0) return { text: "Sin dolor", color: "emerald", risk: "bajo" };
  if (s <= 3) return { text: "Dolor leve", color: "emerald", risk: "bajo" };
  if (s <= 6) return { text: "Dolor moderado", color: "amber", risk: "medio" };
  return { text: "Dolor intenso", color: "red", risk: "alto" };
};
